import User from "./User";
import * as _ from "lodash";

export class UserLookup {
  supervisors = new Map<string, Set<string>>();
  private usersById = new Map<string, User>();
  private usersByStaffNumber = new Map<string, User>();
  private usersByNickname = new Map<string, User>();

  get users() {
    return [...this.usersById.values()];
  }

  getUser(userId: string) {
    return this.usersById.get(userId);
  }

  getUserByIdOrNicknameOrStaffNumber(val: string) {
    return this.usersById.get(val) || this.usersByNickname.get(val) || this.usersByStaffNumber.get(val);
  }

  isUserSupervisorOfTarget(user: User, targetUserId?: string | null) {
    if (!targetUserId) {
      return false;
    }

    return this.supervisors.get(targetUserId)?.has(user.id) ?? false;
  }

  getUserIdFromUserIdentifier(userIdentifier: string) {
    return (
      this.usersById.get(userIdentifier)?.id ??
      this.usersByStaffNumber.get(userIdentifier)?.id ??
      this.usersByNickname.get(userIdentifier)?.id ??
      null
    );
  }

  constructor(users: User[]) {
    users.forEach((user) => {
      this.usersById.set(user.id, user);

      if (user.staffNumber) {
        this.usersByStaffNumber.set(user.staffNumber, user);
      }

      this.usersByNickname.set(user.nickname, user);
    });

    const usersNotDeleted = users.filter((user) => !user.deleted);
    const usersById = _.keyBy(usersNotDeleted, (user) => user.id);

    const visited = new Set<string>();

    usersNotDeleted.forEach((user) => {
      visited.clear();

      const supervisorsOfUser = new Set<string>();
      let toVisit = user.supervisorId;

      while (!!toVisit && !visited.has(toVisit)) {
        visited.add(toVisit);

        const manager = usersById[toVisit];

        if (manager) {
          supervisorsOfUser.add(toVisit);
          toVisit = manager.supervisorId;
        }
      }

      this.supervisors.set(user.id, supervisorsOfUser);
    });
  }
}
